import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateRoute',
})
export class TranslateRoutePipe implements PipeTransform {

  transform(value: string[], lang: 'en' | 'es'): string[] {
    if(lang === 'en') {
      return ['/', ...value];
    } else {
      return ['/es', ...value];
    }
  }

}
